import { cva, type VariantProps } from "class-variance-authority"

/**
 * Enhanced Button Variants using New Component Architecture
 * Integrates with design token system and eliminates technical debt
 */

// Base button foundation using new component architecture
const baseButtonStyles = "btn-base touch-component-target focus-component-ring transition-component gpu-accelerate"

export const buttonVariants = cva(
  baseButtonStyles,
  {
    variants: {
      variant: {
        // Modern variants using new component architecture
        default: "btn-primary",
        primary: "btn-primary",
        secondary: "btn-secondary", 
        ghost: "btn-ghost",
        outline: "btn-outline",
        link: "btn-link",
        destructive: "btn-destructive",
        
        // Legacy variants - maintained for backward compatibility
        // These will be deprecated in favor of the new variants above
        "quotable-primary": "btn-primary",
        "quotable-secondary": "btn-secondary",
        "quotable-ghost": "btn-ghost",
      },
      size: {
        // Modern sizes using component tokens
        default: "btn-md",
        sm: "btn-sm", 
        lg: "btn-lg",
        xl: "btn-xl",
        icon: "btn-icon",
        
        // Legacy sizes - maintained for backward compatibility
        "quotable-default": "btn-md px-component-lg py-component-md sm:px-component-xl sm:py-component-lg",
        "quotable-lg": "btn-lg px-component-xl py-component-md sm:px-component-2xl sm:py-component-lg",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
)

/**
 * Performance-optimized button variants for critical path rendering
 * These use minimal CSS for faster initial load
 */
export const criticalButtonVariants = cva(
  "btn-critical",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground border-primary",
        secondary: "bg-secondary text-secondary-foreground border-primary",
        ghost: "bg-transparent text-muted-foreground border-transparent",
      },
      size: {
        default: "",
        sm: "text-sm px-3 py-1.5",
        lg: "text-lg px-6 py-3",
      },
    },
    defaultVariants: {
      variant: "primary", 
      size: "default",
    },
  }
)

export type ButtonVariants = VariantProps<typeof buttonVariants>